import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { BehaviorSubject, map, Observable, tap } from 'rxjs';
import { ModuleAccess } from '../model/module-permission.model';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root',
})
export class LoginService {

  private moduleAccessList: ModuleAccess[] = [
    {
      moduleName: 'Dashboard',
      permissions: {
        view: false,
        add: false,
        edit: false,
        delete: false,
        blockUnblock: false,
        update: false
      }
    },
  ];
  private moduleAccessSubject = new BehaviorSubject<ModuleAccess[]>(this.moduleAccessList);
  moduleAccessList$ = this.moduleAccessSubject.asObservable();

  private rolePathSubject = new BehaviorSubject<string>('');
  rolePath$ = this.rolePathSubject.asObservable();

  private currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any>;

  getModuleAccessList(): ModuleAccess[] {
    return this.moduleAccessSubject.getValue();
  }
  updateModuleAccessList(newList: ModuleAccess[]) {
    this.moduleAccessSubject.next(newList);
  }

  currentUserDetails: any
  private jwtHelper = new JwtHelperService();


  constructor(private _httpClient: HttpClient) {
    this.loggedinUserSession()
    // this.currentUserSubject = new BehaviorSubject<any>(JSON.parse(sessionStorage.getItem('token') as string));
    this.currentUserSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('token') as string));
    this.currentUser = this.currentUserSubject.asObservable();
  }


  // loginAdminUser(payloads: any) {
  //   return this._httpClient.post(`${environment.base}admin/login`, payloads);
  // }

  loginAdminUser(payloads: any) {
    return this._httpClient.post(`${environment.base}admin/login`, payloads).pipe(
      tap((response: any) => {
        // sessionStorage.setItem('token', JSON.stringify(response));
        localStorage.setItem('token', JSON.stringify(response));
        this.loggedinUserSession();
        this.currentUserSubject.next(response)
      })
    );
  }

  resetPassword(payloads: any) {
    return this._httpClient.post(`${environment.base}admin/sendForgotPasswordLink`, payloads).pipe(
      tap((response: any) => {
        this.currentUserSubject.next(response)
      })
    );
  }

  forgotPassword(payloads: any) {
    return this._httpClient.put(`${environment.base}admin/forgotPassword`, payloads).pipe(
      tap((response: any) => {
        this.currentUserSubject.next(response)
      })
    );
  }

  checkPasswordLinkValidity(payload: any) {
  return this._httpClient.post(`${environment.base}admin/checkPasswordLinkValidity`, payload).pipe(
    tap((response: any) => {
      // If you want to update any state (optional)
      // this.currentUserSubject.next(response);

      return response;
    })
  );
}

  


  updateUserPermission(id: any) {
    return this._httpClient.get(`${environment.base}admin/getUserLoginData/${id}`).pipe(
      tap((response: any) => {
        // sessionStorage.setItem('token', JSON.stringify(response));
        localStorage.setItem('token', JSON.stringify(response));
        // console.log('Permission changed - new token stored in localStorage', response);
        this.loggedinUserSession();
        this.currentUserSubject.next(response)
      })
    );
  }
 logoutAdminUser() {
  this.currentUserSubject.next(null);

  const token = localStorage.getItem('token'); // or sessionStorage
  const headers = { Authorization: `Bearer ${token}` };
  return this._httpClient.delete(
    `${environment.base}admin/private/logout`,
    { headers }
  );
}

  accountsLoginList() {
    return this._httpClient.get(
      `${environment.base}admin/private/accountsLogin`
    );
  }
  accountsLogoutById(id: any) {
    return this._httpClient.delete(
      `${environment.base}admin/private/signout/${id}`
    );
  }
  changePassword(payloads: any) {
    return this._httpClient.put(
      `${environment.base}admin/private/changePassword`,
      payloads
    );
  }
  profileUpdate(payloads: any) {
    return this._httpClient.put(
      `${environment.base}admin/private/editProfile`,
      payloads
    );
  }
  getUserDetailsById(payloads: any) {
    const id = payloads
    return this._httpClient.get(
      `${environment.base}admin/private/user/${id}`,
      payloads
    );
  }

  loggedinUserSession(): void {
    // const sessionData = sessionStorage.getItem('token');
    const sessionData = localStorage.getItem('token');
    if (sessionData) {
      const data = JSON.parse(sessionData);
      this.currentUserDetails = data?.data?.user;

      if (this.currentUserDetails?.userType === 'subadmin') {
        const accessStrings: string[] = this.currentUserDetails.roleData?.access || [];
        const mapped: ModuleAccess[] = accessStrings.map(s => {
          // build a minimal ModuleAccess object — adapt to your real ModuleAccess shape
          return {
            moduleName: s, // or map to module label
            permissions: { view: true, add: false, edit: false, delete: false, blockUnblock: false, update: false }
          };
        });
        this.updateModuleAccessList(mapped);
      }

      // admin does not need moduleAccess updates
      this.rolePathSubject.next(this.getRolePath());
    }
  }

  modulePermission(permissionKeyOrModule: string, action?: string): Observable<boolean> {
    if (this.currentUserDetails?.userType === 'admin') {
      return new Observable<boolean>((observer) => {
        observer.next(true); // always allow for admin
        observer.complete();
      });
    }

    const userPermissions: string[] =
      this.currentUserDetails?.roleData?.access || [];

    return new Observable<boolean>((observer) => {
      let hasPermission = false;

      if (action) {
        const moduleToResource: Record<string, string> = {
          'Dashboard': 'dashboard',
          'User Management': 'users',
          'Article Management': 'article',
          'Poll Management': 'poll',
          'Category Management': 'category',
          'Manage Advertisement': 'advertisement',
          'Manage Advertiser': 'advertiser',
          'Department Titles Management': 'departmentTitle',
          'Role Management': 'role',
          'Member Management': 'member',
          'Feedback Management': 'feedback',
          'Term And Conditions': 'termsAndConditions',
          'Privacy Policy': 'privacypolicy',
          'About Us': 'aboutus',
          'FAQs': 'faq',
          'Notification Management': 'notification'
        };

        const resource = moduleToResource[permissionKeyOrModule];
        if (resource) {
          const permissionKey = `${action}:${resource}`;
          hasPermission = userPermissions.includes(permissionKey);
        }
      } else {
        hasPermission = userPermissions.includes(permissionKeyOrModule);
      }

      observer.next(hasPermission);
      observer.complete();
    });
  }

  private getRolePath(): string {
    return this.currentUserDetails?.userType === 'admin'
      ? ''
      : this.currentUserDetails?.userType === 'subadmin'
        ? 'subadmin'
        : '';
  }

  public get currentUserValue() {
    return this.currentUserSubject.value;
  }

  isTokenExpired(token: any) {
    return this.jwtHelper.isTokenExpired(token);
  }

  public get getToken() {
    // let data: any = JSON.parse(sessionStorage.getItem('token') as string);
    let data: any = JSON.parse(localStorage.getItem('token') as string);
    return data?.data.accessToken;
  }
}
